import { render, staticRenderFns } from "./Weightbox.vue?vue&type=template&id=40b9761b&"
import script from "./Weightbox.vue?vue&type=script&lang=js&"
export * from "./Weightbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports